export enum SubscriptionId {
  OneMonthPlan = 'one_month_plan',
  ThreeMonthPlan = 'three_month_plan',
  OneYearPlan = 'one_year_plan',
  Test = 'test',
}
